import { Calendar } from 'lucide-react';

export interface ChatBubbleProps {
  side: 'in' | 'out';
  sender?: string;
  body: string;
  time: string;
}

export function ChatBubble({ side, sender, body, time }: ChatBubbleProps) {
  return (
    <div className={`mk-bubble mk-bubble--${side}`}>
      {sender ? <p className='mk-bubble__sender'>{sender}</p> : null}
      <p className='mk-bubble__body'>{body}</p>
      <p className='mk-bubble__time'>
        {time}
        <Calendar
          className='mk-bubble__dateicon'
          size={10}
          strokeWidth={2.2}
          aria-hidden='true'
        />
      </p>
    </div>
  );
}
